<template>
	<div id="BlogArchive">
	<section class="articles-archived block--gray block--padding-60">

        <div class="block--heading-select has-thumb">
            <h2 class="titler">{{ title }}</h2>
            <catdropdown v-if="categoried" :dataList="categoried" :selection.sync="currentCategory" ></catdropdown>
            <div class="thumb-bg" :style="postThumb"></div>
        </div>

        <div class="message message--info" v-if="userErrorInfo">{{userErrorInfo}}</div>
        <transition-group v-on:enter="enterAnimationListStagged" v-on:before-enter="beforeEnterAnimation" v-on:leave="leaveAnimationListStagged"  v-if="posts" name="enter-list" tag="ul" class="post-list-archived">
         	<li class="list-post-item" v-for="(post, key) in posts" :data-index="key" :key="post.id">
				<singlepost :postdata="post"></singlepost>
            </li>
        </transition-group>

        <preloader class="posts-preload" v-if="loadingPosts"></preloader>

        <div v-if="(currentPage < maxPages)" class="text--center text--uppercase load-button-block">
	        <button class="btn btn--text" @click="loadPosts">
                {{ buttonLoadLabel }}
                <span class="load-icon">
                    <svg width="24px" height="20px" viewBox="0 0 24 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="Arkiv-aktuelt" transform="translate(-524.000000, -1634.000000)" fill-rule="nonzero" fill="#000000">
                                <g id="Group-8" transform="translate(353.000000, 1632.000000)">
                                    <g id="refresh51" transform="translate(171.000000, 2.000000)">
                                        <path d="M11.8181818,18.1818182 C8.99363636,18.1818182 6.50363636,16.75 5.03272727,14.5736364 L2.92272727,14.5736364 C4.58363636,17.7963636 7.94363636,20 11.8181818,20 C17.0345455,20 21.3181818,16.0054545 21.7772727,10.9090909 L23.6363636,10.9090909 L20.9090909,7.27272727 L18.1818182,10.9090909 L19.95,10.9090909 C19.4981818,15 16.03,18.1818182 11.8181818,18.1818182 Z" id="Shape"></path>
                                        <path d="M11.8181818,0 C6.91636364,0 2.83818182,3.52727273 1.98272727,8.18181818 L0,8.18181818 L2.72727273,11.8181818 L5.45454545,8.18181818 L3.83909091,8.18181818 C4.66545455,4.53818182 7.92454545,1.81818182 11.8181818,1.81818182 C14.2790909,1.81818182 16.4854545,2.90454545 17.9854545,4.62363636 L18.3363636,4.53363636 L20.1927273,4.53363636 C18.4072727,1.80363636 15.3236364,0 11.8181818,0 Z" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                </span>
            </button>
        </div>
	</section>
	</div>
</template>
<style type="scss">
.flip-list-move {
  transition: transform 1s;
}
</style>
<script>

    import postBlock from './components/postBlock.vue';
    import preloader from './components/preloader.vue';
    import catDropdown from './components/categoryList.vue';


    import axios from 'axios';

export default {
    name: 'BlogArchive',
    components: {
         'singlepost' : postBlock,
         'catdropdown' : catDropdown,
         'preloader' : preloader,
	},
	data () {
		return {
            buttonLoadLabel: theme_data.strings.load_more,
            title: theme_data.strings.news,
            loadingPosts: false,
            userErrorInfo: false,
            posts: [],
            currentCategory: 0,
			currentPage: 0,
            totalPosts: 0,
            maxPages: 1,
            no_found_rows:  0,
            post_type: 'posts',
            info: null,
            per_page: 6   ,
            categoried: [
                {
                    'name' : theme_data.strings.loading,
                    'id' : 0,
                    'selected' : true,
                },
            ]
		}
    },
    computed: {
        postThumb() {
            if(theme_data.post_thumb){
                return 'background-image: url("'+theme_data.post_thumb+'")';
            }else{
                return null;
            }

        }
    },
    watch: {
        currentCategory: function (val) {
            this.info = 'changed category to: '+ val;
            this.currentCategory = parseInt(this.currentCategory);
            this.restartQuerry();
            this.loadPosts();
        },
        categoried: function(val){

        }
    },
	methods: {
        beforeEnterAnimation(el ){

        },
        enterAnimationStaggerFrom(el){

        },


        restartQuerry(){
            this.no_found_rows  = 0;
            this.currentPage = 0;
            this.posts = [];
            this.info = 'Querry restarted';
            this.userErrorInfo = false;
        },
        loadCats(){
            var self = this;
            axios.get( theme_data.api+'bahr/v2/load_cat_list/', {
                    params: {
                        lang: theme_data.language,
                        nocache: new Date().getTime()
                    }
            })
            .then(function (response) {
                //self.info = response.data;
                let categoried = [
                    {
                        'name' : theme_data.strings.select_categories,
                        'id' : 0,
                        'selected' : true,
                    }
                ];
                self.categoried = categoried.concat(response.data.categories);


            })
            .catch(function (error) {
                    self.info = 'Error! Could not reach the API. ' + error
            })
        },
        loadPosts: function(){
            var self = this;

            if( self.currentPage < self.maxPages && !self.loadingPosts ){
                self.currentPage++;
            }else{
                self.info = 'No more posts to load';
                return;
            }
            self.loadingPosts = true;
            axios.get( theme_data.api+'bahr/v2/posts_list_blog/', {
                    params: {
                        lang: theme_data.language,
                        posts_per_page: self.per_page,
                        paged: self.currentPage,
                        category__in: self.currentCategory,
                        no_found_rows: self.no_found_rows,
                       // offset: ( (parseInt(self.currentPage) -1 ) * parseInt(self.per_page))
                    }
            })
            .then(function (response) {
                if(response.data.info){
                   self.totalPosts = parseInt(response.data.info.found_posts);
                   self.maxPages = parseInt(response.data.info.max_num_pages);
                    /* self.$nextTick(function(){
                        //self.enterAnimationStaggerFrom('.list-post-item');
                    }); */
                }
                self.no_found_rows = 1; // only first time need to make heavy querry

                if(response.data.posts_data){
                    self.userErrorInfo = false;
                    self.posts = self.posts.concat(response.data.posts_data);
                }else{
                    self.userErrorInfo = theme_data.strings.nothing_to_show;
                }

                self.loadingPosts = false;

            })
            .catch(function (error) {
                    self.info = 'Error! Could not reach the API. ' + error
            })
        },

    },
    mounted: function(){
        this.loadPosts();
        this.loadCats();
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue/BlogArchive.vue?2bdaacd5